import React from 'react'
import { Progress, Row, Col } from 'antd'

const Noncomplete = (props) => {
  const { token, data, word } = props
  const TotalCalculated = (values) => {
    let M = `${values}`

    if (M === 'NaN') {
      return '0'
    } else {
      return M
    }
  }
  return (
    <div className="noncomplete-container">
      <h3 className="colorHeader">
        {' '}
        {word['Non_completed']} {word['VS']}. {word['Completed']}
      </h3>
      <div className="progress">
        <Progress
          success={{
            percent: `${data?.percent_completed}`,
          }}
          trailColor="#Efefef"
          type="circle"
          strokeWidth={14}
          width={160}
          strokeLinecap="butt"
          format={(percent) => `${percent} Days`}
        ></Progress>
        <div className="totalProject">
          <p>{word['Total']}</p>
          <h1>{TotalCalculated(data.project_noncompleted + data.project_completed)}</h1>
          <p>{word['projects']}</p>
        </div>
      </div>

      <Row className="Footer">
        <Col className="Left" span={12}>
          <div className="inbox">
            <div className="point status_noncomplete"></div>
            <div className="pertext-content">
              <p>{word['Non_completed']}</p>
              <h3>{data?.percent_noncompleted}%</h3>
              <p className="colorp">
                ( {data?.project_noncompleted} {word['projects']} )
              </p>
            </div>
          </div>
        </Col>
        <Col className="Right" span={12}>
          <div className="inbox">
            <div className="point status_complete"></div>
            <div className="pertext-content">
              <p>{word['Completed']}</p>
              <h3>{data?.percent_completed}%</h3>
              <p className="colorp">
                ( {data?.project_completed} {word['projects']} )
              </p>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  )
}
export default Noncomplete
